// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"6cc5f473","160":"3cc21fdd","208":"7d717c7a","293":"8fa90963","516":"1b3cc634","519":"65a0b6f5","917":"28a8127a","946":"084e42f3"}[chunkId] + ".chunk.js";
};